module.exports = __webpack_public_path__ + "img/slika4_2022.f095f143.png";